import { httpClient } from '../../../httpClient';

import { MessageForm } from '../components/SendMessage';
import { IContactDetailsRs } from '../models';

export const getConfig = (): Promise<IContactDetailsRs> => {
    return httpClient.get(`configs`);
};

export const sendMessage = (form: MessageForm): Promise<IContactDetailsRs> => {
    const formData = new FormData();

    Object.entries(form).forEach(([key, value]) => {
        formData.set(key, value);
    });

    return httpClient.post(`contact`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
